import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import {
  setReportClient,
  openGPReportPDF,
  openFPReportPDF
} from '../../actions/advisor';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
} from '../../constants.js';
import s from './ClientReport.css';

class ClientReport extends PureComponent {

  componentWillMount() {
    const {
      reportClient,
    } = this.props;
    const name = reportClient.firstName + '-' + reportClient.lastName;
    this.props.openGPReportPDF(reportClient.id, name);
    this.props.openFPReportPDF(reportClient.id, name);
  }

  closeReport() {
    this.props.setReportClient(null);
  }

  getLastTestResult(test) {
    const {
      reportClient,
    } = this.props;
    const results = reportClient.results.filter((result) => result.name === test);
    if(results.length > 0) {
      return results[results.length -1];
    } else {
      return null;
    }
  }

  render() {
    const {
      reportClient
    } = this.props;
    const LA = this.getLastTestResult(LA_TEST);
    const NF = this.getLastTestResult(NF_TEST);
    const RR = this.getLastTestResult(RR_TEST);
    return (
      <div className={s.clientReport}>
        <div className="row">
          <div className={s.header + ' col-md-5'}>
            <div style={{paddingTop:'10px'}}>{reportClient.firstName} {reportClient.lastName}</div>
          </div>
          <div className={`${s.header} ${s.headerRT} col-md-6`}>
            <a id="gp-report-download" className={s.downloadFPButton}>Fetching Client Report</a>
            <a id="fp-report-download" className={s.downloadFPButton}>Fetching Advisor Report</a>
          </div>
          <div className={`${s.header} ${s.headerRT} col-md-1`}>
            <div className={s.closeIcon} onClick={() => this.closeReport()}/>
          </div>
        </div>
        <div className="row" style={{backgroundColor:'#F8F8F8'}}>
          { reportClient.tests.includes(LA_TEST) && LA &&
          <div className={'col-md-12 ' + s.body}>
            <div className={s.headline}>Loss Aversion</div>
            <div className={s.subhead}>Client Feedback</div>
            <div className={s.copy} dangerouslySetInnerHTML={{__html: LA.result}}/>
            <div className={s.copy}><br /><strong>How do you compare to others?</strong><br /><br /></div>
            <ReactEcharts option={ this.getChart(LA.score) } style={{ height: 200 }} />
            <div className={s.subhead}>Advisor Tips</div>
            <div className={s.subcopy} dangerouslySetInnerHTML={{__html: LA.tip}}/>
            <div className={s.subhead}>WisdomTree Model Portfolio Solution</div>
            <div className={s.subcopy}>
              You may want to consider tailoring your client portfolios based on the following criteria:
              <ol>
                <li>Frequency that you review the portfolio with your client</li>
                <li>Your client’s age</li>
                <li>Sensitivity of your client’s spouse</li>
                <li>Frequency that your client looks at their portfolio and may be concerned with its performance</li>
              </ol>
            </div>
            <div className={s.subcopy} dangerouslySetInnerHTML={{__html: LA.model}}/>
            <div className={s.footer + ' col-md-12'} />
          </div>
          }
          { reportClient.tests.includes(NF_TEST) && NF &&
          <div className={'col-md-12 ' + s.body}>
            <div className={s.headline}>Big Picture Assessment</div>
            <div className={s.subhead}>Client Feedback</div>
            <div className={s.copy} dangerouslySetInnerHTML={{__html: NF.result}}/>
            <div className={s.subhead}>Advisor Tips</div>
            <div className={s.subcopy} dangerouslySetInnerHTML={{__html: NF.tip}}/>
            <div className={s.footer + ' col-md-12'} />
          </div>
          }
          { reportClient.tests.includes(RR_TEST) && RR &&
          <div className={'col-md-12 ' + s.body}>
            <div className={s.headline}>Retirement Regret</div>
            <div className={s.subhead}>Client Feedback</div>
            <div className={s.copy} dangerouslySetInnerHTML={{__html: RR.result}}/>
            <div className={s.subhead}>Advisor Tips</div>
            <div className={s.subcopy} dangerouslySetInnerHTML={{__html: RR.tip}}/>
            <div className={s.footer + ' col-md-12'} />
          </div>
          }
        </div>
      </div>
    );
  }

  getChart(scores) {
    const score = scores[0];
    let idx;
    if(score < 1.15) {
      idx = 0;
    } else if (score < 4) {
      idx = 1;
    } else {
      idx = 2;
    }

    const colors = ['#8C959B','#8C959B','#8C959B'];
    colors[idx] = '#35ccd2';
    const labelTop = {
      show: true,
      fontSize:20,
      fontWeight:'bold',
      color:'#FFFFFF',
      position: 'insideBottom',
    };
    return {
      color: colors,
      grid: {
          top: '30',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
      },
      xAxis : [
        {
          type : 'category',
          data : ['Gain Seeking or Experience Gains & Losses Equally', 'Loss Averse', 'More Loss Averse'],
          axisLine: {
            lineStyle: {
                color: '#5b6770',
            },
          },
          axisTick: {
            show: false,
            interval: function () { return 1; },
          },
          axisLabel: {
            show: true,
            fontSize: 14,
            interval: function () { return 1; },
          },
        },
      ],
      yAxis : [
        {
          type : 'value',
          max: 36,
          axisLabel: {show: false},
          axisTick: {show: false},
          splitLine: {show: false},
          axisLine: {show: false},
        },
      ],
      series : [
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          data: [{value: 36, label: labelTop},0,0],
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  if(params.value === 36) {
                    return '36%';
                  } else {
                    return '';
                  }
                },
            },
          },
        },
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          data: [0,{value: 31, label: labelTop},0],
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  if(params.value === 31) {
                    return '31%';
                  } else {
                    return '';
                  }
                },
            },
          },
        },
        {
          type: 'bar',
          barWidth: '90%',
          barGap:'-100%',
          silent: true,
          data: [0,0,{value: 33, label: labelTop}],
          label: {
            normal: {
                show: false,
                formatter: function (params) {
                  if(params.value === 33) {
                    return '33%';
                  } else {
                    return '';
                  }
                },
            },
          },
        },
      ],
    };
  }
}

function mapStateToProps(state) {
  return {
    reportClient: state.advisorData.reportClient,
    apiURL: state.params.apiURL,
  };
}

export default connect(mapStateToProps, {
  setReportClient,
  openGPReportPDF,
  openFPReportPDF,
})(ClientReport);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/ClientReport.js